<template>
    <div class="conditions">
        <div v-if="type === 'over'">
            <p class="conditions-tip"><strong>服务介绍</strong></p>
            <p>当快件超过承诺时效送达，且经确认不属于《超时退费派送服务保证及免责条款》范围内的情形，运费付款方客户可在快件签收后申请超时退费。</p>
            <p class="conditions-tip"><strong>适用范围</strong></p>
            <p>
                中国大陆地区互寄的<a
                    href="https://www.sf-express.com/mobile/cn/sc/express/express_service/mainland_area/one_day_arrve/"
                    target="_blank"
                    >顺丰即日</a
                >、<a href="https://www.sf-express.com/mobile/cn/sc/express/express_service/mainland_area/next_morning_arrve/" target="_blank"
                    >顺丰次晨</a
                >服务。
            </p>
            <p class="conditions-tip"><strong>退费方式</strong></p>
            <p>月结客户：运费在下一期月结账单中抵免。</p>
            <p>非月结客户：可获赠以短信形式发送的顺丰电子券，可用于抵免下一次寄件的同额运费。</p>
            <p>点击查阅<a href="https://www.sf-express.com/cn/sc/other/electronic_coupons/" target="_blank">《顺丰电子券使用说明》</a></p>
            <p>查询及申请渠道</p>
            <p>您可致电顺丰客户服务热线95338进行退费申请。</p>
            <p class="conditions-tip"><strong>温馨提醒</strong></p>
            <p>
                由于天气异常、自然灾害、政府行为、军事演习、安检查验、航空管制、地面交通管制等不可抗力因素及收寄双方客户原因导致的时效延误不承诺退费或赔偿，详情可查阅<a
                    href="https://www.sf-express.com/cn/sc/other/delivery_agreement/"
                    target="_blank"
                    >《超时退费派送服务保证及免责条款》</a
                >
            </p>
            <p>客户需在快件签收后60天内提出退费申请；</p>
            <p>快件运费付款方享有超时退费的服务；</p>
            <p>退还费用仅含运费，不包括增值服务费在内的其他费用</p>
        </div>
        <div v-else>
            <div v-if="priceRuleDetail" v-html="priceRuleDetail"></div>
            <div v-else class="news-content">
                <div class="conditions-tip">
                    <p class="conditions-tip">
                        <strong
                            ><span><span>一、运费计算基于以下计费规则：</span></span></strong
                        >
                    </p>
                    <p class="conditions-tip">
                        <strong
                            ><span>
                                1.&nbsp;&nbsp;
                                <span>体积重量计算方法</span></span
                            ></strong
                        >
                    </p>
                    <p>
                        <span>
                            托寄物的计费重量取体积重量与实际重量两者之间的较大值，若为子母件，则将每件的计费重量进行汇总后计算总运费，其中，体积重量的计算方法为：
                        </span>
                    </p>
                    <p>
                        <span>【</span>
                        <strong>
                            <span>
                                <span>顺丰即日</span>
                                /顺丰特快
                            </span>
                        </strong>
                        <span>】</span>
                    </p>
                    <p>
                        &nbsp;
                        <span>同城、省内以及经济区域内互寄，体积重量</span>
                        <span style="font-family: Verdana">=</span> <span>长</span> <span style="font-family: Verdana">(CM)×</span> <span>宽</span>
                        <span style="font-family: Verdana">(CM)×</span> <span>高</span> <span style="font-family: Verdana">(CM)÷12000</span>
                        <span>；</span>
                    </p>
                    <p>
                        &nbsp;
                        <span>省外跨经济区域互寄，体积重量</span>
                        <span style="font-family: Verdana">=</span> <span>长</span> <span style="font-family: Verdana">(CM)×</span> <span>宽</span>
                        <span style="font-family: Verdana">(CM)×</span> <span>高</span> <span style="font-family: Verdana">(CM)÷6000</span>
                        <span>；</span>
                    </p>
                    <p>
                        &nbsp;
                        <span style="font-family: Verdana">(</span>
                        <span>经济区域包含：京津冀区域，江浙沪皖区域</span>
                        <span>，川渝区域，黑吉辽区域</span>
                        <span style="font-family: Verdana">)</span>
                    </p>
                    <p>
                        <span>【</span>
                        <strong
                            ><span><span>顺丰标快</span></span></strong
                        >
                        <span>】</span>
                    </p>
                    <p>
                        &nbsp;
                        <span>中国内地大部分流向互寄，体积重量</span>
                        <span style="font-family: Verdana">=</span> <span>长</span> <span style="font-family: Verdana">(CM)×</span> <span>宽</span>
                        <span style="font-family: Verdana">(CM)×</span> <span>高</span> <span style="font-family: Verdana">(CM)÷12000</span>
                        <span>；</span>
                    </p>
                    <p>
                        &nbsp;
                        <span>中国内地其他地区与昌都市互寄、华南、华北至西藏流向互寄，体积重量</span>
                        <span style="font-family: Verdana">=</span> <span>长</span> <span style="font-family: Verdana">(CM)×</span> <span>宽</span>
                        <span style="font-family: Verdana">(CM)×</span> <span>高</span> <span style="font-family: Verdana">(CM)÷6000</span>
                        <span>；</span>
                    </p>
                    <p>
                        <span>【</span>
                        <strong
                            ><span
                                ><span>顺丰卡航</span>
                                /
                                <span>冷运标快</span></span
                            ></strong
                        >
                        <span>】</span> <span>体积重量</span>
                        =
                        <span>长</span> <span style="font-family: Verdana">(CM)×</span> <span>宽</span>
                        <span style="font-family: Verdana">(CM)×</span> <span>高</span> <span style="font-family: Verdana">(CM)÷6000</span>
                        <span>；</span>
                    </p>
                    <p>
                        <span>【</span>
                        <strong
                            ><span><span>冷运零担</span></span></strong
                        >
                        <span>】</span> <span>体积重量</span>
                        =
                        <span>长</span> <span style="font-family: Verdana">(CM)×</span> <span>宽</span>
                        <span style="font-family: Verdana">(CM)×</span> <span>高</span> <span style="font-family: Verdana">(CM)÷3000</span>
                        <span>；</span>
                    </p>
                    <p>
                        <strong
                            ><span
                                ><span>【港澳台（服务）】</span>
                                &nbsp;
                            </span></strong
                        >
                        <span>体积重量</span>
                        =
                        <span>长</span> <span style="font-family: Verdana">(CM)×</span> <span>宽</span>
                        <span style="font-family: Verdana">(CM)×</span> <span>高</span> <span style="font-family: Verdana">(CM)÷6000</span>
                    </p>
                    <p>
                        <strong
                            ><span><span>【国际快递（服务）】</span></span></strong
                        >
                        <span>体积重量</span>
                        =
                        <span>长</span> <span style="font-family: Verdana">(CM)×</span> <span>宽</span>
                        <span style="font-family: Verdana">(CM)×</span> <span>高</span> <span style="font-family: Verdana">(CM) ÷5000</span>
                    </p>
                    <p>
                        <span>其他产品计算方法请致电</span>
                        95338
                        <span>或咨询当地收派员。</span>
                    </p>
                    <p class="conditions-tip">
                        <strong
                            ><span>
                                2.
                                <span>计费重量小数点进位处理方式</span></span
                            ></strong
                        >
                    </p>
                    <p>
                        <strong
                            ><span><span>【中国内地互寄业务】</span></span></strong
                        >
                        10KG
                        <span>以下，续重以</span> <span style="font-family: Verdana">0.1KG</span>
                        <span>为计重单位，四舍五入保留</span>
                        <span style="font-family: Verdana">1</span> <span>位小数；</span> <span style="font-family: Verdana">10-100KG</span>
                        <span>，续重以</span>
                        <span style="font-family: Verdana">0.5KG</span>
                        <span>为计重单位，采用</span>
                        <span style="font-family: Verdana">2378</span> <span>制（</span> <span style="font-family: Verdana">2</span> <span>退</span>
                        <span style="font-family: Verdana">3</span> <span>进</span> <span style="font-family: Verdana">7</span> <span>退</span>
                        <span style="font-family: Verdana">8</span> <span>进）；</span>
                        <span style="font-family: Verdana">100KG</span>
                        <span>及以上，四舍五入取整数。</span>
                    </p>
                    <p>
                        <strong
                            ><span><span>【港澳本地业务】</span></span></strong
                        >
                        <span>续重以</span>
                        0.5KG
                        <span>为计重单位，不足</span>
                        <span style="font-family: Verdana">0.5kg</span> <span>，按</span> <span style="font-family: Verdana">0.5kg</span>
                        <span>计。</span>
                    </p>
                    <p>
                        <strong
                            ><span><span>【中国内地始发至港澳台业务】</span></span></strong
                        >
                        100KG
                        <span>以下</span> <span style="font-family: Verdana">,</span> <span>续重以</span>
                        <span style="font-family: Verdana">0.5KG</span>
                        <span>为计重单位，不足</span>
                        <span style="font-family: Verdana">0.5kg</span> <span>，按</span> <span style="font-family: Verdana">0.5kg</span>
                        <span>计；</span> <span style="font-family: Verdana">100KG</span> <span>及以上，以</span>
                        <span style="font-family: Verdana">1KG</span>
                        <span>为计重单位，小数点后尾数大于零的，向上进位至下一个</span>
                        <span style="font-family: Verdana">1KG</span> <span>。</span>
                    </p>
                    <p>
                        <strong
                            ><span><span>【中国内地始发至海外国家及地区业务】</span></span></strong
                        >
                        20KG
                        <span>以下</span> <span style="font-family: Verdana">,</span> <span>续重以</span>
                        <span style="font-family: Verdana">0.5KG</span>
                        <span>为计重单位，不足</span>
                        <span style="font-family: Verdana">0.5kg</span> <span>，按</span> <span style="font-family: Verdana">0.5kg</span>
                        <span>计；</span> <span style="font-family: Verdana">20KG</span> <span>及以上，以</span>
                        <span style="font-family: Verdana">1KG</span>
                        <span>为计重单位，小数点后尾数大于零的，向上进位至下一个</span>
                        <span style="font-family: Verdana">1KG</span> <span>。</span>
                    </p>
                    <p class="conditions-tip">
                        <strong
                            ><span>
                                3.
                                <span>运费计算结果处理方式</span></span
                            ></strong
                        >
                    </p>
                    <p>
                        -
                        <span>运费计算结果按四舍五入取整数值；</span>
                    </p>
                    <p>
                        -
                        <span>不同产品起始重量各有差异，不足起重的快件将按起重计费并显示。</span>
                    </p>
                    <p>
                        <span>以上计费规则可能因服务（产品）或所在地区不同而有所差异，详情致电</span>
                        95338
                        <span>或与当地收派员进行咨询。</span>
                    </p>
                    <p>&nbsp;</p>
                    <p class="conditions-tip">
                        <strong
                            ><span><span>温馨提示：</span></span></strong
                        >
                    </p>
                    <p>
                        <strong
                            ><span><span>一、时效标准</span></span></strong
                        >
                    </p>
                    <p>
                        1
                        <span>、预计时效因节假日、天气、交通管控、资源等原因不同日期时间查询会有所差异，具体以系统实时返回为准。</span>
                    </p>
                    <p>
                        <strong
                            ><span><span>二、始发地或目的地任一方为港澳台地区：</span></span></strong
                        >
                    </p>
                    <p>
                        1
                        <span>、此价格供参考。更多收费和服务详情，详情请致电中国内地客户服务热线</span>
                        <span style="font-family: Verdana">&nbsp;</span>
                        <strong><span>95338</span></strong> <span>。</span>
                    </p>
                    <p>
                        2
                        <span>、中国台湾地区寄往中国内地包裹价格查询仅供参考，更多物品的运费查询请</span>
                        <a href="https://www.sf-express.com/cn/sc/download/202006Dynamic_function-pric-TW-C-type.pdf"
                            ><span style="text-decoration: underline"
                                ><span class="15"><span>按此</span></span></span
                            ></a
                        >
                        <span>查询，参考时效在顺丰标快产品基础上加时</span>
                        3-5
                        <span>天。</span>
                    </p>
                    <p>
                        3
                        <span>
                            、对于约定由收件人或第三方付费（含运费及增值服务费）的快件，在快件签收之前，可提出对费用付款方式变更为寄方付。对于需要更改付款方式的快件，寄件人除需要支付运费外，每票需另外支付更改付款方式服务费。详见具体
                        </span>
                        <a href="http://www.sf-express.com/cn/sc/express/express_service/added_service/change_payment_method/"
                            ><span style="text-decoration: underline"
                                ><span class="15"><span>收费标准</span></span></span
                            ></a
                        >
                        <span>。</span>
                    </p>
                    <p>
                        4
                        <span>、如收派件地址为</span>
                        <a href="http://www.sf-express.com/hk/tc/download/HK_RemoteArea_TC.pdf"
                            ><span style="text-decoration: underline"
                                ><span class="15"><span>香港地区偏远地区</span></span></span
                            ></a
                        >
                        <span>，收派件时效需加</span>
                        1
                        <span>个工作日。</span>
                    </p>
                    <p>
                        5
                        <span>、中国台湾地区部分地区收派时效需加</span>
                        <span style="font-family: Verdana">0.5-1</span> <span>工作日，可</span>
                        <a href="http://www.sf-express.com/cn/sc/download/TW_Remote_area_TC01.PDF"
                            ><span style="text-decoration: underline"
                                ><span class="15"><span>按此</span></span></span
                            ></a
                        >
                        <span>查阅详情。</span>
                    </p>
                    <p>
                        6
                        <span>、以上由中国香港、中国澳门及中国台湾地区寄件至中国内地，以及中国港澳台地区之间互寄</span>
                        <span style="font-family: Verdana">,</span>
                        <span>运费已包含燃油附加费。燃油附加费说明请</span>
                        <a href="http://www.sf-express.com/cn/sc/dynamic_function/price/fuel_surcharge_introduction.html"
                            ><span style="text-decoration: underline"><span>按此</span></span></a
                        >
                        <span>了解。</span>
                    </p>
                    <p>
                        <strong
                            ><span
                                ><span>三、始发地或目的地任一方为海外国家</span>
                                :
                            </span></strong
                        >
                    </p>
                    <p>
                        1
                        <span>、以上查询的流向价格与时效仅供参考。具体服务及收费详情，请致电国际业务客服专线</span>
                        <span style="font-family: Verdana">9533883.</span>
                    </p>
                    <p>
                        2
                        <span>、以上查询的流向运费已包含燃油附加费（请</span>
                        <a href="http://www.sf-express.com/cn/sc/dynamic_function/price/international_fuel_surcharge_introduction.html"
                            ><span style="text-decoration: underline"><span>按此</span></span></a
                        >
                        <span>了解更多燃油附加费的资料），但未包含清关税费、偏远地区附加费、住宅派送附加费、特殊处理费等可能产生的其他费用。</span>
                    </p>
                    <p>
                        3
                        <span>
                            、时效标准天数是指工作日，不包含收件日，不包括周末和节假日。具体派送时效以目的地邮编为准。如遇偏远地区或郊区、航班延误、清关异常等情形，时效会额外增加。时效为参考时效，非承诺时效。
                        </span>
                    </p>
                    <p>
                        4
                        <span>
                            、在清关资料齐全且不存在自扣与海关扣等风险或异常的情况，以下情况需在参考时效的基础上增加时长：中国内地、港澳台进口的个人物品和正式报关货件增加
                        </span>
                        <span style="font-family: Verdana">1-2</span>
                        <span>个工作日，中国内地进口的分运行李货件增加</span>
                        <span style="font-family: Verdana">2-4</span>
                        <span>个工作日，中国内地、港澳台出口的正式报关货件增加</span>
                        <span style="font-family: Verdana">1</span>
                        <span>个工作日，海外国家进口的正式报关货件增加</span>
                        <span style="font-family: Verdana">2-3</span> <span>个工作日。</span>
                    </p>
                    <p>
                        5
                        <span>
                            、为降低因收发件人信息、申报品名不完整或错误及申报价值不符等原因导致的清关风险；收发件人信息必须真实有效，托寄物品名需写明材质和用途，托寄物价值必须如实申报。如因以上原因造成的查验延误，及产生的相关所有费用将与相关税费一起向寄件人或者收件人收取。
                        </span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import ajax from '@/api/ajax'
export default {
    name: 'PriceRule',
    props: {
        // 是否隐藏头部
        noHead: {
            type: String,
            default: 'false'
        },
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            priceRuleDetail: ''
        }
    },
    created() {
        if (this.type === 'over') {
            this.setTitle('超时退费说明')
        } else {
            this.setTitle('运费时效说明')
            const params = {
                'filters[type][$eq]': 'owfRateCalcRules'
            }
            this.$route.meta.cmsApi &&
                ajax[this.$route.meta.cmsApi]({ params }).then(res => {
                    this.priceRuleDetail = res && res.length !== 0 ? res[0].content : ''
                })
        }
        this.setShowHeader(!(this.noHead === 'true'))
        this.setShowCustomer(true)
    },
    methods: {
        ...mapMutations(['setShowCustomer']),
        ...mapMutations({
            setTitle: 'setTitle',
            setShowHeader: 'setShowHeader'
        })
    }
}
</script>

<style lang="scss" scoped>
a {
    color: #ec2200;
    text-decoration: underline;
}
.conditions {
    background-color: #fff;
    border-radius: 0.04rem;
    padding: 0.2rem;
    p {
        line-height: 0.34rem;
        font-size: 0.26rem;
        padding-left: 0.3rem;
        color: #333;
        margin-bottom: 0.1rem;
    }
    .tw-tip {
        color: rgb(68, 114, 196);
    }
    .conditions-tip {
        padding-left: 0;
        font-size: 0.3rem;
        margin-bottom: 0.2rem;
        margin-top: 0.2rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/price/rule.vue